export const buildStyleAttributes = (attr = {}) => {
  const extra = attr.color ? { WebkitTextFillColor: attr.color } : {}

  return { ...attr, ...extra }
}

/* Returns an invisible RGB if no hex is provided */
export const hexToRgb = (hex, alpha = 1) => {
  if (!hex) return `rgba(0,0,0,0)`

  const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16))

  return `rgba(${r},${g},${b},${alpha})`
}

export const buildForceColorFullString = color => `color:${color};fill:${color};-webkit-text-fill-color:${color};`
